import { postData } from './http';

import ProductType = Core.Booking.ProductType;

const baseUrl: string = '/api2/basketcrosssell/';
const cache = new Map();
const urlFragments = {
    [ProductType.Transfer]: 'ranktransferoptions',
    [ProductType.Parking]: 'rankparkingoptions',
    [ProductType.CarHire]: 'rankcarhireoptions'
};

class EnhancedRanking {
    Key: string;
    Rank: number;
    Price: number;
}

class RankingRequest {
    BasketId: string;
    ApplicationType: number;
    DomainId: number;
    Product: any[];
}

function createRankingRequest(basketId: string,
                              type: ProductType,
                              products: any[]): RankingRequest {
    let req = new RankingRequest();
    req.BasketId = basketId;
    req.ApplicationType = TRPCONFIG.ApplicationType;
    req.DomainId = TRPCONFIG.Domain.DomainId;

    //nasty bit
    switch (type) {
        case ProductType.Transfer:
            req.Product = _.map(products, t => ({ Type: t.Type }));
            break;
        case ProductType.Parking:
            req.Product = _.map(products, p => ({ Title: p.CarPark }));
            break;
        case ProductType.CarHire:
            req.Product = _.map(products, p => ({ Description: p.Description }));
            break;
        default:
            throw new Error('Unsupported ProductType:' + type);
    }

    return req;
}

function rankProducts(url: string,
                      request: RankingRequest,
                      type: ProductType,
                      products: any[]) {
    return postData<any>(url, request, { logErrors: false }).then(function(data) {
        if (!data || data.length === 0) {
            throw new Error('No rankings to order by :' + url);
        }

        let rankings;

        switch (type) {
            case ProductType.Transfer:
                data.Transfers.forEach(function(r) {
                    r.Key = r.Type;
                    delete r.Type;
                    r.Price = _.find(products, { Type: r.Key }).TotalPrice;
                });

                let transfers:any = [];
                rankings = sortRankings(data.Transfers);
                for (let i = 0; i < rankings.length; i++) {
                    const idx = _.findIndex(products, t => t.Type === rankings[i].Key);
                    transfers.push(products[idx]);
                    products.splice(idx, 1);
                }
                return transfers;

            case ProductType.Parking:
                data.Parking.forEach(function(r) {
                    r.Key = r.Title;
                    delete r.Title;
                    r.Price = _.find(products, { CarPark: r.Key }).Price;
                });

                let parking:any = [];
                rankings = sortRankings(data.Parking);
                for (let i = 0; i < rankings.length; i++) {
                    const idx = _.findIndex(products, p => p.CarPark === rankings[i].Key);
                    parking.push(products[idx]);
                    products.splice(idx, 1);
                }
                return parking;

            case ProductType.CarHire:
                data.CarHire.forEach(function(r) {
                    r.Key = r.Description;
                    delete r.Description;
                    r.Price = _.find(products, { Description: r.Key}).Price;
                });

                let carhire:any = [];
                rankings = sortRankings(data.CarHire);
                for (let i = 0; i < rankings.length; i++) {
                    const idx = _.findIndex(products, c => c.Description === rankings[i].Key);
                    carhire.push(products[idx]);
                    products.splice(idx, 1);
                }
                return carhire;
        }

        throw new Error('Unsupported ProductType:' + type);
    });
}

function compare(x, y, asc) {
    if (x === y) {
        return 0;
    }
    const m = asc ? 1 : -1;
    return (x > y) ? 1 * m : -1 * m;
};

// Method to help us sort the ranking results
function sortRankings(rankings: EnhancedRanking[]): EnhancedRanking[] {
    const sorted = _.clone(rankings);

    sorted.sort(function(x, y) {
        const r1 = x.Rank;
        const r2 = y.Rank;

        if (r1 !== r2) {
            return compare(r1, r2, false);
        } else {
            return compare(x.Price, y.Price, true);
        }
    });

    return sorted;
}

export function rankProductResults(basketId: string,
                                   type: ProductType,
                                   availabilityId: string,
                                   products: any[]): Promise<any[]> {
    if (!products || products.length === 0) {
        return Promise.resolve(products);
    }

    if (availabilityId && cache.has(availabilityId)) {
        return Promise.resolve(cache.get(availabilityId));
    }

    const request = createRankingRequest(basketId, type, products);

    return rankProducts(baseUrl + urlFragments[type], request, type, products)
        .then(data => {
            cache.set(availabilityId, data);
            return data;
        })
        .catch(() => products);
}
